/**
 * Transforms a lower_case string to Title Case
 * @param {string} str - String in lower_case format
 * @returns {string} String in Title Case format
 */
export function lowerCaseToTitleCase(str) {
  return str
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}

/**
 * Capitalizes the first letter of every word in a string
 * @param {string} str - Any string
 * @returns {string} String with every word capitalized
 */
export function capitalizeWords(str) {
  return str
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}

/**
 * Capitalizes only the first letter of the string
 * @param {string} str - Any string
 * @returns {string} String with only the first letter capitalized
 */
export function capitalizeFirst(str) {
  if (!str) return str;
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}
